import { getYearsSince } from "utils/tools";
import * as Yup from "yup";

export const RocksFormValidation = Yup.object({
    accountableID: Yup.string()
        .required("Accountable is required")
        .uuid("Must be a valid UUID"),

    statusId: Yup.string()
        .optional()
        .uuid("Must be a valid UUID"),

    quarter: Yup.string()
        .required("Quarter is required")
        .length(2, "Quarter must be exactly 2 characters (e.g. Q1, Q2)"),

    year: Yup.string()
        .required("Year is required")
        .length(4, "Year must be a 4-digit year (e.g. 2025)")
        .matches(/^\d{4}$/, "Year must be numeric"),

    rocks: Yup.string()
        .required("Rock description is required")
        .max(3000, "Maximum length is 3000 characters"),

    helpFrom: Yup.string()
        .nullable()
        .max(250, "Maximum length is 250 characters"),

    dateOfCompletion: Yup.date()
        .nullable()
        .typeError("Must be a valid date"),

    description: Yup.string()
        .required("Comments are required")
        .max(1000, "Maximum length is 1000 characters"),
});



const STARTING_YEAR = 2005
export const YEARS = getYearsSince(STARTING_YEAR);
export const QUARTERS = ["Q4", "Q3", "Q2", "Q1"]
